import { GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import { s__ } from '~/locale';
import WorkspaceStateIndicator from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/workspaces/common/components/workspace_state_indicator.vue?vue3';
import WorkspaceActions from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/workspaces/common/components/workspace_actions.vue?vue3';
import { calculateDisplayState } from '../../common/services/calculate_display_state';
import { WORKSPACE_STATES } from '../constants';
export default {
    name: 'WorkspaceDropdownItem',
    components: {
        GlLink,
        WorkspaceStateIndicator,
        WorkspaceActions,
        TimeAgoTooltip
    },
    i18n: {
        created: s__('Workspaces|Created')
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        workspace: {
            type: Object,
            required: true
        }
    },
    emits: [
        'update-workspace'
    ],
    computed: {
        displayState () {
            return calculateDisplayState(this.workspace.actualState, this.workspace.desiredState);
        },
        isRunning () {
            return this.displayState === WORKSPACE_STATES.running;
        }
    },
    methods: {
        trackOpenWorkspace () {
            this.track('click_consolidated_edit', {
                label: 'workspace'
            });
        }
    }
};
